import React from "react";
import $ from "jquery";
import * as actions from "../actions/actions";
import { connect } from "react-redux";
import styled from "styled-components";
import Sticky from "react-stickynode";
import classnames from "classnames";

import AppsFeature from "./nounproject-appsfeature";
import IconAPICustomBlock from "./nounproject-customblock-icon-api";
import BestCollection from "./nounproject-best-collection";
import BlogCarousel from "./nounproject-blog-carousel";
import FeaturedCollection from "./nounproject-featured-collection";
import IconsForEverythingHeader from "./nounproject-icons-everything-header";
import PrePaidCustomBlock from "./nounproject-customblock-prepaid";
import DiversityCustomBlock from "./nounproject-customblock-diversity";
import TentPoles from "./nounproject-tentpoles";
import UserCarousel from "./nounproject-creator-carousel";
import NounProjectSearch from "./nounproject-search";

require("../../sass/components/nounproject-homepage.sass");

import { compensateForStickyHeader, breakpoints } from "./shared";

const PageContainer = styled.section`
    ${compensateForStickyHeader};

    .homepage-search {
        padding: 0;
        margin-bottom: 8px;
    }

    .sticky-inner-wrapper {
        @media (min-width: ${breakpoints.sm}rem) and (max-width: ${breakpoints.beforeTablet}rem) {
            width: 90%;
            margin: 0 auto;
            svg {
                top: 0.96rem;
                left: 1rem;
            }

            input {
                padding: 0.875rem 1rem 0.875rem 2.625rem;
            }
        }

        @media (min-width: ${breakpoints.md}rem) {
            width: 95%;
            margin: 0 auto;
        }

        padding-left: 0;
        padding-right: 0;
        max-width: 940px;
        margin: 0 auto;
    }

    .stuck-searchbar .sticky-inner-wrapper {
        left: 50%;
        transform: translateX(-50%) !important;
        max-width: 940px;
        margin: 0 auto;
        top: 23px !important;
        z-index: 9999;

        @media (min-width: ${breakpoints.sm}rem) and (max-width: ${breakpoints.beforeTablet}rem) {
            top: 15px !important;
            margin: 0 0 0 73px !important;
            left: auto;
            transform: none !important;
            svg {
                top: 0.45rem;
                left: 0.6rem;
            }
            input {
                padding: 0.375rem 0.625rem 0.375rem 1.75rem;
            }
        }
        @media (min-width: 768px) and (max-width: 768px) {
            top: 28px !important;
        }
        @media (min-width: ${breakpoints.sm}rem) {
            width: 52% !important;
        }

        @media (min-width: 49rem) {
            width: 63% !important;
            margin: 0 auto;
        }

        @media (min-width: ${breakpoints.lg}rem) {
            width: 56.45% !important;
            max-width: 864px;
            margin: 0 auto;
        }
    }
`;

class NounProjectHomepage extends React.PureComponent {
    componentWillMount() {
        this.props.fetchFeaturedCollectionMetaData();
    }

    constructor(props) {
        super(props);
        // dismiss old welcome modal
        $("#welcome_screen .inner .button").on("click", e => {
            e.preventDefault();
            $("#welcome_screen").removeClass("visible");
        });

        this.state = {
            featuredCollections: [],
            searchBarZ: 1
        };
    }

    render() {
        let featuredCollections = this.props.featuredCollectionsKeys.map(
            collectionId => this.props.collections[collectionId]
        );

        let featuredCollectionComponents;
        if (featuredCollections.length) {
            featuredCollectionComponents = (
                <React.Fragment>
                    <FeaturedCollection
                        collectionIndex={0}
                        adSpace={true}
                        maxIcons={12}
                        collectionMetadata={featuredCollections}
                    />
                    <AppsFeature />
                    <FeaturedCollection
                        collectionIndex={1}
                        maxIcons={12}
                        collectionMetadata={featuredCollections}
                    />
                    <DiversityCustomBlock />
                    <FeaturedCollection
                        collectionIndex={2}
                        maxIcons={12}
                        collectionMetadata={featuredCollections}
                    />
                    <UserCarousel />
                    <FeaturedCollection
                        collectionIndex={3}
                        maxIcons={12}
                        collectionMetadata={featuredCollections}
                    />
                    <IconAPICustomBlock />
                    <FeaturedCollection
                        collectionIndex={4}
                        maxIcons={12}
                        collectionMetadata={featuredCollections}
                    />
                </React.Fragment>
            );
        }

        let handleStateChange = status => {
            if (status.status === Sticky.STATUS_FIXED) {
                $("body").addClass("search-is-sticky");
            } else {
                $("body").removeClass("search-is-sticky");
            }
        };

        let classes = classnames("homepage-container ");
        let stickyOffset = this.props.hasTopBanner ? 50 : 0;
        let enableTransforms = !this.props.hasTopBanner;
        // new SiteHeader does not account for hasTopBanner - we need to account for this

        return (
            <PageContainer className={classes}>
                <IconsForEverythingHeader />
                <Sticky
                    enableTransforms={enableTransforms}
                    top={stickyOffset}
                    activeClass="stuck-searchbar"
                    onStateChange={handleStateChange}
                >
                    <div className="homepage-search">
                        <NounProjectSearch />
                    </div>
                </Sticky>
                <BestCollection />
                <TentPoles />
                <PrePaidCustomBlock />
                {featuredCollectionComponents}
                <BlogCarousel />
            </PageContainer>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let hasTopBanner = !!Object.keys(state.banners.all).length;
    return {
        featuredCollectionsKeys: state.collections.keys || [],
        collections: state.collections,
        hasTopBanner
    };
}

export default connect(mapStateToProps, {
    fetchFeaturedCollectionMetaData: actions.fetchFeaturedCollectionMetaData
})(NounProjectHomepage);
